<template>
  <div v-bind:class="['my-4 mx-md-5 mx-lg-10 mx-xl-10 pa-2 pt-md-0 px-md-4 mt-0 maxw-1750', {
    'px-4': !$vuetify.breakpoint.mdAndUp,
  }]">
    <!-- loader skeleton -->
    <template v-if="loading">
      <v-row no-gutters class="flex-row flex-nowrap">
        <v-skeleton-loader type="avatar" class="mr-4" width="60" />
        <v-skeleton-loader type="heading" class="py-3" width="100%" />
      </v-row>
      <v-card v-bind:class="['mt-4 py-4', {
        'px-2': !$vuetify.breakpoint.mdAndUp,
        'px-4': $vuetify.breakpoint.mdAndUp
      }]">
        <v-skeleton-loader type="text" />
        <v-skeleton-loader class="mt-4" type="paragraph" />
      </v-card>
    </template>

    <template v-else-if="item != null">
      <v-card
        class="mt-4"
      >
        <div class="card__title--notification d-flex flex-row align-center">
          <div class="notification-card-icon mr-2">
            <div class="pa-2">
              <v-avatar
                color=""
                size="25"
              >
                <v-icon dark>{{ getIcon(itemSelected.type) }}</v-icon>
              </v-avatar>
            </div>
          </div>

          <h3>{{ (item.origen === 'sms' || item.origen === 'whatsapp') || item.subject == null
            ? truncarText(item.text)
            : item.subject }}
          </h3>
        </div>
        <v-card-text
          v-if="item.bussinessType !== 'news'"
          v-bind:class="{ 'pb-0': !$vuetify.breakpoint.mdAndUp }">
          <span
            v-if="item.creationDate"
          >
            <b>{{ $t('views.notificationDetails.received') }}:</b> {{ item.creationDate }}
          </span>
        </v-card-text>

        <v-card-text
          v-if="item.bussinessType !== 'news'"
          class="body-1 black--text notification-body"
          v-html="item.text">
        </v-card-text>

        <v-card-text
          v-if="item.bussinessType === 'news'"
          class="body-1 black--text notification-body"
          v-html="item.zinfo_usuariofinal">
        </v-card-text>
      </v-card>
    </template>

    <template v-else>
      <h3>{{ $t('views.notificationDetails.detailTitle') }}</h3>
      <v-card class="mt-4">
        <v-card-text class="text-subtitle-2">
          {{ $t('views.notificationDetails.notFound') }}
        </v-card-text>
      </v-card>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    backButton: Boolean,
    item: Object,
    loading: Boolean,
    id: [String, Number],
    itemAllList: [],
  },
  data() {
    return {
      itemSelected: {},
    };
  },
  beforeRouteUpdate(to, from, next) {
    if ([from.name, to.name].every((name) => name === 'NotificationsDetailView')) {
      this.getItem(to.params.id);
    }
    next();
  },
  methods: {
    getItem(id) {
      this.$emit('request', { type: 'detail', args: { id } });
    },
    getIcon(type) {
      return this.$getConst(`notificationsView.icon.${type}`);
    },
    truncarText(texto) {
      if (texto && texto.length > 50) {
        return `${ texto.slice(0, 50) }...`;
      }
      return texto;
    },
  },
  computed: {
    itemDate() {
      const { creationDate } = this.item;
      if (creationDate == null) {
        return null;
      }

      const dateMoment = this.$date('moment', creationDate);
      const dateTime = dateMoment.format('DD/MM/YYYY [a las] HH:mm:ss');
      const timeAgo = dateMoment.fromNow();

      return `${dateTime} (${timeAgo})`;
    },
  },
  mounted() {
    this.getItem(this.id);
  },
  watch: {
    loading() {
      if (!this.loading) {
        this.itemSelected = this.itemAllList
          .find((itemNoti) => itemNoti.id === this.item.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .card__title--notification {
    padding: 16px 16px 0 3px;
  }
  .notification-body {
    overflow-x: auto;
  }
  .icon-ayudadigital-arroba:before {
    color: white !important;
  }
  .icon-ayudadigital-appmovil:before {
    color: white !important;
  }
  .icon-ayudadigital-whatsapp:before {
    color: white !important;
  }
  .notification-card-icon div div i:before {
    color: #27846d!important;
  }
  .font__size--2 > i:before {
    font-size: 2rem!important;
  }
</style>
